export const getLargePhotos = ({ photoGallery }) => photoGallery.get('largePhotos', []);

export const getCurrentPhotoId = ({ photoGallery }) => photoGallery.get('currentPhotoId', null);

export const getCurrentPhoto = ({ photoGallery }) => (
  photoGallery.getIn(['largePhotos', `${photoGallery.get('currentPhotoId')}`], null)
);

export const getIsCurrentPhotoLoading = ({ photoGallery }) => (
  photoGallery.getIn(['largePhotos', `${photoGallery.get('currentPhotoId')}`, 'isLoading'], false)
);
